import { useState } from 'react';
import evaluationOpportunityRequestsApi from 'Api/axios/evaluation-opportunity-requests-api';
import type { OpportunityRequestListItemI, OpportunityRequestsQueryI, PaginationMetaI } from 'types';

/**
 * Fetches the paginated list of opportunity requests for a course.
 * Exposes data, pagination, loading, error, and a fetch trigger.
 */
const useOpportunityRequestsList = (courseId: string, query: OpportunityRequestsQueryI = {}) => {
  const [data, setData] = useState<OpportunityRequestListItemI[] | null>(null);
  const [pagination, setPagination] = useState<PaginationMetaI | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetch = async () => {
    setLoading(true);
    setError(null);

    const response = await evaluationOpportunityRequestsApi.listByCourse(courseId, query);

    if (response.data !== undefined) {
      setData(response.data);
      setPagination(response.pagination ?? null);
    } else {
      setError(response.error ?? 'Error al cargar las solicitudes');
    }

    setLoading(false);
  };

  return { data, pagination, loading, error, fetch };
};

export default useOpportunityRequestsList;
